"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var check_1 = require("../check");
var RadioGroup_1 = require("./RadioGroup");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
exports.Radio = forward_ref_with_statics_1.forwardRefWithStatics(function (props, ref) {
    return react_1.default.createElement(check_1.Check, tslib_1.__assign({ ref: ref, type: "radio" }, props));
}, 
// statics
{
    Group: RadioGroup_1.RadioGroup,
});
exports.Radio.displayName = "Radio";
//# sourceMappingURL=Radio.js.map